import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';



@Injectable({
  providedIn: 'root'
})
export class ApploadServiceService {

  constructor(private httpClient: HttpClient) {  }

  initializeApp(): Promise<any> {
    return new Promise<void>((resolve, reject) => {
      console.log("AppInitService.init() called");
    
      setTimeout(() => {
          console.log('AppInitService Finished');
          resolve();
      }, 2000);

  });
  }
}
